import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { menuItems } from "components/Menu/Datamenu";
import { useDispatch } from "react-redux";
import { addCategoryToCart } from "store/features/cartSlice";
import servicesApi from "api/service/service.api";
import ProcessingBar from "Util/Processingbar";
import ProcessingBar2 from "Util/ProcessingBar2";

const mobilePromos = [
  {
    id: "promo-burger",
    image: "/saigonstar/bghero.webp",
    alt: "Burger Promotion",
  },
  {
    id: "promo-chicken",
    image: "/saigonstar/our1.webp",
    alt: "Chicken Burger Promotion",
  },
];

const Cate = () => {
  const [active, setActive] = useState(null);

  const [menuCategory, setMenuCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const gridRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true);

      try {
        const { response, err } = await servicesApi.getMenuCategoryPublic();

        if (response?.data?.categories) {
          setMenuCategory(response.data.categories);
        }

        if (err) {
          console.error("Error loading categories:", err);
        }
      } catch (error) {
        console.error("Unexpected error loading categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (gridRef.current && !gridRef.current.contains(e.target)) {
        setActive(null); // reset active
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();

  return (
    <section className="bg-darkbg py-40 px-0 lg:px-6">
      <div className="max-w-6xl mx-auto">
        {/* TITLE */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center text-4xl font-heading text-neonYellow animate-neonFlicker mb-16"
        >
          Order Takeaway
        </motion.h2>

        {/* GRID */}

        {isLoading ? (
          <div className="min-h-[300px] flex items-center">
            {" "}
            <ProcessingBar />
          </div>
        ) : (
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-0 lg:gap-3 justify-items-center "
            ref={gridRef}
          >
            {menuCategory.map((cat, index) => {
              const isActive = active === cat.id;

              return (
                <motion.div
                  key={cat.id}
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  // onClick={() => {
                  //   setActive(cat.id);
                  //   navigate(`/menu`);
                  // }}

                  onClick={() => {
                    setActive(cat._id);

                    dispatch(addCategoryToCart(cat));

                    navigate(`/menu`);
                  }}
                  className={`
    w-full max-w-[280px] min-h-[300px]
    aspect-square
    mx-auto
    flex flex-col items-center justify-center
    p-6 rounded-2xl cursor-pointer
    transition-all duration-300
    ${isActive ? "bg-dry text-yellowstar shadow-lg" : "hover:bg-dry/5 text-dry hover:border hover:border-dotted hover:border-dry"}
  `}
                >
                  {/* IMAGE */}
                  <div className="w-[180px] h-[180px] rounded-full overflow-hidden bg-white/10 mb-4">
                    <img
                      src={cat.image}
                      alt={cat.label}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* TEXT */}
                  <div className="text-center flex flex-col items-center">
                    <p className="font-semibold text-lg leading-snug line-clamp-2">
                      {cat.name}
                    </p>

                    <p className="flex items-center gap-2 text-sm mt-2 hidden lg:flex">
                      <FaCircle
                        className={`text-[6px] ${
                          isActive ? "text-yellowstar" : "text-dry"
                        }`}
                      />
                      <span
                        className={isActive ? "text-white/80" : "text-gray-500"}
                      >
                        {cat.itemCount} items
                      </span>
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
      {/* MOBILE PROMOS */}
      <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-6 max-w-6xl mx-auto">
        {mobilePromos.map((promo, index) => {
          const isBurger = promo.id === "promo-burger";

          return (
            <motion.div
              key={promo.id}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`
          overflow-hidden rounded-2xl
          ${isBurger ? "md:col-span-8" : "md:col-span-4"}
          h-[180px] md:h-[300px] lg:h-[340px]
        `}
            >
              <img
                src={promo.image}
                alt={promo.alt}
                className="w-full h-full object-cover"
              />
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Cate;
